/*
 * @Author: CYX
 * @Date: 2020-07-09 18:38:50
 * @LastEditors: CYX
 * @LastEditTime: 2020-07-10 09:22:12
 */ 
export const InquirySheetDetailsEn = {
    xunjiadanList: "Inquiry list",
    xunjiadandetail: "Inquiry details",
    baojiadan: " quotation",
    xunjiadan: " inquiry list",
    ceshixinxi: "The test information",
    wenjiansc:'File upload:',
    baojiazhong: "in the quotation",
    baojiaxinxi: "quotation information",
    feiyongheji: "total amount of expenses：",
    chongxinbaojia: "To quote",
    querenxiandan: "Confirm the order",
    baopjiayouxiaoqi: "The offer is valid until",
    zaiyouxiaoqqxd: "Please confirm your order before the expiry date",
    ptbzxx: "Platform Remarks",
    sfcxbj: "Whether to offer again",
    zhankai: "unfold",
    shouqi: "store away",
}


// WEBPACK FOOTER //
// ./src/lang/home/InquirySheetDetails/indexEn.js